import React from 'react';

const Image = ({ src, alt, displayType }) => (
  <img
    style={{ display: displayType }}
    src={src}
    alt={alt}
    data-ppuc-id="Image"
  />
);

Image.defaultProps = {
  alt: '',
  displayType: 'inline',
};

export default Image;
